<template>
    <div>
        <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-7">
                <h4>
                    <span
                        @click="hasHistory() ? $router.go(-1) : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Система мотивации B2B менеджеров
                </h4>
            </div>
            <div class="col-sm-12 col-md-5 text-right" v-if="!underConstruction && !unavaibleForYou">
                <b-button
                    v-if="onlyForCelebrity() && mainParameters && mainParameters.fixed==false"
                    size="sm"
                    variant="reload"
                    class="mr-2"
                    title="Больше цифры изменить будет нельзя, создастся слепок месяца"
                    @click="fixMotivationResults()"
                >
                    Зафиксировать
                </b-button>
<!--                <router-link to="/motivation/report" v-if="onlyForHeads()">-->
<!--                    <b-button-->
<!--                        size="sm"-->
<!--                        variant="reload"-->
<!--                        class="mr-2"-->
<!--                    >-->
<!--                        Итоги-->
<!--                    </b-button>-->
<!--                </router-link>-->

                <b-button
                    @click="updateMotivationData()"
                    size="sm"
                    variant="reload"
                    class="mr-2"
                    title="Перерасчёт займет несколько минут"
                    v-if="(onlyForHeadsOfOtdels() || onlyForHeads()) && mainParameters && mainParameters.fixed==false"
                >
                    <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="updatingMotivationData ? 'spin' : ''"></b-icon>
                </b-button>

<!--                <template v-if="onlyForHeads()">-->
<!--                    <b-form-select v-model="userFilterByOtdel" :options="optionsOfOtdel" size="sm" class="mb-2" style="max-width: 195px"></b-form-select>-->
<!--                </template>-->

                <b-form-select 
					v-model="selectedMonth" 
					size="sm" 
					style="max-width: 195px" 
					:options="monthRange"
				></b-form-select>
                <div class="text-right mt-2 mb-2">
                    <router-link v-if="(onlyForHeadsOfOtdels() || onlyForHeads()) && mainParameters && mainParameters.fixed==false" class="btn btn-outline-secondary ml-2" :to="`/motivation/scoring/${selectedMonth}`">Оценить сотрудников</router-link>
                </div>
            </div>
        </div>

        <template v-if="!underConstruction && !unavaibleForYou">
            <template v-if="onlyForHeadsOfOtdels() || onlyForHeads()">
                <div class="mb-5">
                    <MotivationUserTable
                        :period-range="monthRange"
                        :selected-period="selectedMonth"
                        :is-updating.sync="updateUserTable"
                        :userFilterByOtdel="userFilterByOtdel"
                        @showMotivationByUserId="showMotivationByUserId"
                        @showHandMotivationByUserId="showHandMotivationByUserId"
                        @setMainParameters="setMainParameters"
                        @setData="setData"
                    ></MotivationUserTable>
                </div>
    <!--            <div class="mb-5">-->
    <!--                <template v-if="onlyForHeads() || (currentUser.role && (currentUser.role.includes('sales-head-manager')))">-->
    <!--                    <MotivationSalesKPI-->
    <!--                        :month-range="monthRange"-->
    <!--                        :selected-month="selectedMonth"-->
    <!--                        :is-updating.sync="updateUserTable"-->
    <!--                    ></MotivationSalesKPI>-->
    <!--                </template>-->

    <!--                <template v-if="onlyForHeads() || (currentUser.role && (currentUser.role.includes('TO-head-manager') || currentUser.role.includes('logistics-head-manager')))">-->
    <!--                    <MotivationTOLOGISTICKPI-->
    <!--                        :month-range="monthRange"-->
    <!--                        :selected-month="selectedMonth"-->
    <!--                        :is-updating.sync="updateUserTable"-->
    <!--                    ></MotivationTOLOGISTICKPI>-->
    <!--                </template>-->
    <!--            </div>-->
            </template>
            <template v-if="!onlyForHeadsOfOtdels() && !onlyForHeads()">
                <div class="mb-5">
                    <MotivationForOneUser
                        :period-range="monthRange"
                        :selected-period="selectedMonth"
                        :is-updating.sync="updateUserTable"
                        @showMotivationByUserId="showMotivationByUserId"
                        @showHandMotivationByUserId="showHandMotivationByUserId"
                        :motivationHeader="monthRange.length > 0 ? outNowPeriodName() : ''"
                    ></MotivationForOneUser>
                </div>
            </template>

            <tsoft-motivation-finance-list
                v-if="motivationList.length > 0 && openMotivationFinanceList"
                :openFinanceList="openMotivationFinanceList"
                :financeList="motivationList"
                :userIds="motivationUserIds"
                :need-group="true"
                :need-itogs="false"
                label="Список поставок и счетов, участвующих в расчетах"
                @closeFinanceList="closeMotivationList"
            />

            <tsoft-motivation-list
                v-if="motivationList.length > 0 && openMotivationList"
                :openMotivationList="openMotivationList"
                :motivationList="motivationList"
                :needEdition="openMotivationListNeedEdition"
                @closeMotivationList="closeMotivationList"
            >
            </tsoft-motivation-list>
        </template>
        <template v-if="underConstruction && !unavaibleForYou">
            <b-jumbotron>
                <template #header>
                    <h3 class="display-4">Раздел в разработке</h3>
                </template>
            
                <template #lead>
                  Мотивация временно недоступна. Вводится версия 5.0.
                </template>
            
                <hr class="my-4">
            
                <p>
                  Работы будут продолжаться в 2025 году.
                </p>
            
            </b-jumbotron>            
        </template>
        <template v-if="unavaibleForYou">
            <b-jumbotron>
                <template #header>
                    <h3 class="display-4">Раздел временно недоступен</h3>
                </template>
            
                <template #lead>
                  Мотивация временно недоступна. Пожалуйста, вернитесь на страницу позже.
                </template>
            
            </b-jumbotron>            
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        API_POST_MOTIVATION_CALCULATION,
        API_POST_MOTIVATION_HAND_RESULTS_BY_USER_ID,
        API_POST_KPI_B2B_RESULT
    } from "../constants"

    import OrderList from '../components/orders/OrderList'
    import MotivationFinanceList from '../components/motivation/MotivationFinanceList'
    import MotivationList from '../components/motivation/MotivationList'
    import MotivationUserTable from "../components/motivation/MotivationUserTable"
    import MotivationSalesKPI from "../components/motivation/MotivationSalesKPI"
    import MotivationTOLOGISTICKPI from "../components/motivation/MotivationTOLOGISTICKPI"
    import MotivationForOneUser from "../components/motivation/MotivationForOneUser"

    import {
        motivationWorkWithDates
    } from "../mixins/motivation/motivationHelpers"

    export default {
        components: {
            "tsoft-order-list": OrderList,
            "tsoft-motivation-finance-list": MotivationFinanceList,
            "tsoft-motivation-list": MotivationList,
            MotivationUserTable,
            MotivationSalesKPI,
            MotivationTOLOGISTICKPI,
            MotivationForOneUser
        },
        mixins: [
            motivationWorkWithDates
        ],
        data() {
            return {
                underConstruction: false,
                unavaibleForYou: false,
                additionalGetParameter: '',
                componentRefreshKey: 0,
                updatingMotivationData: false,
                updateUserTable: false,
                motivationList: [],
                motivationUserIds: [],
                openMotivationFinanceList: false,
                openMotivationList: false,
                openMotivationListNeedEdition: false,
                userFilterByOtdel: 'all',
                optionsOfOtdel: [
                    { value: 'all', text: 'Все сотрудники' },
                    { value: 'suppliers', text: 'Все менеджеры поставок' },
                    { value: 'heads', text: 'Руководство компании' },
                    { value: 'sellers', text: 'Отдел продаж' },
                    { value: 'to_department', text: 'Отдел ТО' },
                    { value: 'ved_department', text: 'Отдел логистики' },
                ],
                mainParameters: {},
                bigData: {}
            }
        },
        watch: {
            $route(to, from) {
                this.additionalGetParameterChanger()
            },
            selectedMonth(month) {
                this.userFilterByOtdel = 'all'
            },
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
        },
        created() {
            this.additionalGetParameterChanger()
        },
        mounted() {
            if (this.$route.params.report_date) {
                this.selectedMonth = this.$route.params.report_date
            }
            if (this.currentUser.id == 77) {
                this.unavaibleForYou = true;
            }
			// if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
			// 	this.currentUser.role.includes("sales-head-manager") ||
			// 	this.currentUser.role.includes("TO-head-manager") ||
			// 	this.currentUser.role.includes("logistics-head-manager") ||
			// 	this.currentUser.role.includes("logistics-multim-head-manager") ||
			// 	this.currentUser.role.includes("president"))) {
			// 		this.underConstruction = false;
			// } else {
			// 		this.underConstruction = true;
			// }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.user_id) {
                    this.additionalGetParameter = `&user_id=${this.$route.params.user_id}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
            updateMotivationData() {
                this.updatingMotivationData = true

                const calculationRequest = {
                    "date_from": this.selectedMonth
                }

                api.call("post", API_POST_MOTIVATION_CALCULATION, calculationRequest).then(({data}) => {
                    this.updateUserTable = true
                    this.updatingMotivationData = false
                }).catch((response) => {
                    if (response.status == 422){
                        this.updateUserTable = false
                    }
                })
            },
            showMotivationByUserId(finance_ids, user_ids) {
                this.motivationList = finance_ids
                this.motivationUserIds = user_ids
                this.openMotivationFinanceList = true
                this.openMotivationListNeedEdition = false
            },
            closeMotivationList(somethingChanged = false) {
                this.motivationList = []
                this.motivationUserIds = []
                this.openMotivationList = false
                this.openMotivationFinanceList = false
                this.openMotivationListNeedEdition = false
                if (somethingChanged) {
                    this.updateUserTable = true
                }
            },
            showHandMotivationByUserId(userId) {
                api.call("post", API_POST_MOTIVATION_HAND_RESULTS_BY_USER_ID, {
                    "date_from": this.selectedMonth,
                    "userId": userId
                }).then(({data}) => {
                    this.motivationList = data
                    this.openMotivationList = true
                    this.openMotivationListNeedEdition = false
                }).catch((response) => {
                    if (response.status == 422){
                    }
                })
            },
            setMainParameters(mainParameters) {
                this.mainParameters = mainParameters
            },
            setData(data) {
                this.bigData = data
            },
            checkMpdInDep(data, depName) {
                if (data["snapshot_data"] &&
                    data["snapshot_data"][depName] &&
                    data["snapshot_data"][depName][0] &&
                    data["snapshot_data"][depName][0] &&
                    data["snapshot_data"][depName][0].parameters &&
                    data["snapshot_data"][depName][0].parameters[0] &&
                    data["snapshot_data"][depName][0].parameters[0].mpd) {
                    return data["snapshot_data"][depName][0].parameters[0].mpd;
                }

                return 0;
            },
            fixMotivationResults() {    
                const data = {
                    snapshot_data: this.bigData,
                    heads_department_value: 0,
                    sales_department_value: 0,
                    to_department_value: 0,
                    teo_department_value: 0,
                    b2b_value: 0,
                    b2b_value_debt: 0,
                    actual_date: this.selectedMonth       
                }

                data["heads_department_value"] = this.checkMpdInDep(data, "Руководство компании")
                data["sales_department_value"] = this.checkMpdInDep(data, "Отдел продаж")
                data["to_department_value"] = this.checkMpdInDep(data, "Отдел ВЭД")
                data["teo_department_value"] = this.checkMpdInDep(data, "Отдел логистики")

                data["b2b_value"] = data["snapshot_data"]["Отдел ВЭД"][0].parameters[0].mpa     // Можно взять у любого отдела. Цифра одинаковая
                let minMpSum = data["snapshot_data"]["goals"]["minMP"]["sum"]
                data["b2b_value_debt"] = data["b2b_value"] < minMpSum ? (minMpSum - data["b2b_value"]) : 0

                api.call("post", API_POST_KPI_B2B_RESULT, data).then(({data}) => {
                    this.mainParameters["fixed"] = true;
                }).catch((response) => {
                    if (response.status == 422){
                    }
                })
            },
            onlyForCelebrity() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            onlyForHeads() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("head-accountant") ||
                    this.currentUser.role.includes("accountant") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            onlyForHeadsOfOtdels() {
                if (this.currentUser.role && (this.currentUser.role.includes("TO-head-manager") ||
                    this.currentUser.role.includes("logistics-head-manager") ||
                    this.currentUser.role.includes("sales-head-manager"))) {
                    return true
                }
                return false
            },
            outNowPeriodName() {
                let period = {
                    text: ''
                }

                period = this.monthRange.find((period, index) => {
                    if (period.value == this.selectedMonth) {
                        return period
                    }
                })

                return period.text == '' ? '' : 'Персональный расчет за ' + period.text + ' г.'
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
<style>
    .custom-select {
        line-height: 21px;
        height: 30px;
        border-radius: 5px;
    }
	.custom-select-sm {
		height: 30px !important;
		line-height: 13px;
		padding-top: 0;
		padding-bottom: 0;
		padding-left: 12px;
	}
</style>
